import { render, staticRenderFns } from "./packageBuy.vue?vue&type=template&id=580d8f9c&scoped=true"
import script from "./packageBuy.vue?vue&type=script&lang=js"
export * from "./packageBuy.vue?vue&type=script&lang=js"
import style0 from "./packageBuy.vue?vue&type=style&index=0&id=580d8f9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d8f9c",
  null
  
)

export default component.exports